@let disable = disabledField() || isReadOnly();
@if(rightLabel()){
<div class="d-flex justify-content-between align-items-center">
  <label  class="naps-label" [class.nsdc-disabled]="disable" [attr.aria-label]="label()">{{label()}}
    @if(isRequired()){<sup class="nsdc-text-important">*</sup>}</label>
  <label   class="right-label" [class.disabled-label]="disableRightLabel()" (click)="disableRightLabel() ? '' : rightLabelButtonClicked.emit('')" [class.naps-underline]="underLinedRightLabel()">
    {{rightLabel()}}
  </label>
</div>
}@else {
<label   class="naps-label" [class.nsdc-disabled]="disable" [attr.aria-label]="label()">{{label()}}
  @if(isRequired()){<sup class="nsdc-text-important">*</sup>}
</label>
}

@if(inputType() == 'textArea' ){
<textarea [class.filled]="(customFormControl()?.value?.toString()?.trim()?.length || 0) > 0 && !disable"
  [class.error]="(isRequired() && (!customFormControl()?.valid && customFormControl()?.touched))"
  [placeholder]="placeholder()" [formControl]="customFormControl()" [attr.aria-label]="ariaLabel()" rows="4" cols="10"
  [attr.disabled]="disable"></textarea>
@if(infoMessage()){
<div class="d-block info-section">
  <i class="sd sd-info-circle"></i> <span class="ml-1">{{ infoMessage() }}</span>
</div>
}
}@else {
  @if(isMasked()){
    <input [class.filled]="(customFormControl()?.value?.toString()?.trim()?.length || 0) > 0 && !disable"
    [class.error]="(isRequired() && (!customFormControl()?.valid && customFormControl()?.touched))" [type]="inputType()"
    [placeholder]="placeholder()" [formControl]="customFormControl()" [attr.aria-label]="ariaLabel()"
    [style.height]="height()+'px'" [attr.disabled]="disable" (dragstart)="preventDrag() && preventDefault($event)"
    (paste)="preventPaste() && preventDefault($event)" (drop)="preventDrop() && preventDefault($event)"
    [attr.maxlength]="customMaxLength()" [attr.minlength]="customMinLength()" (keypress)="customKeyPress.emit($event)"
    (change)="customChange.emit($event)" (keyup)="customKeyUp.emit($event)" (blur)="customBlur.emit($event)"
    [appOnlyNumber]="applyOnlyNumbers()" [appUpperCase]="isAppUpperCase()"
    [mask]="maskPattern()"
    [value]="customValue()" [readOnly]="isReadOnly()">
  }@else {
    <input [class.filled]="(customFormControl()?.value?.toString()?.trim()?.length || 0) > 0 && !disable"
    [class.error]="(isRequired() && (!customFormControl()?.valid && customFormControl()?.touched))" [type]="inputType()"
    [placeholder]="placeholder()" [formControl]="customFormControl()" [attr.aria-label]="ariaLabel()"
    [style.height]="height()+'px'" [attr.disabled]="disable" (dragstart)="preventDrag() && preventDefault($event)"
    (paste)="preventPaste() && preventDefault($event)" (drop)="preventDrop() && preventDefault($event)"
    [attr.maxlength]="customMaxLength()" [attr.minlength]="customMinLength()" (keypress)="customKeyPress.emit($event)"
    (change)="customChange.emit($event)" (keyup)="customKeyUp.emit($event)" (blur)="customBlur.emit($event)"
    [appOnlyNumber]="applyOnlyNumbers()" [appUpperCase]="isAppUpperCase()"
    [value]="customValue()" [readOnly]="isReadOnly()">
  }

}
<ng-content>
  @if(isRequired() && (!customFormControl()?.valid && customFormControl()?.touched) ){
  <div class="nsdc-text-error">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <g clip-path="url(#clip0_40000035_111244)">
        <path
          d="M9 6V9M9 12H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
          stroke="#E22C2C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_40000035_111244">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <span>&nbsp; {{errorMessage()|| 'Please Fill this is a Required Field'}}</span>
  </div>
  }
</ng-content>